<template>
  <section>
    <h3 class="h3Title">발송 내역</h3>
    <div class="fieldWrap tableWrap">
      <ul class="fieldBx">
        <li class="formList">
          <dl>
            <dt class="formTit">기간 검색</dt>
            <dd>
              <date-range-component v-on:event="getSearchDate" label="발송일" :value="param.searchDate"></date-range-component>
            </dd>
            <dd>
              <div class="monthBx">
                <button type="button" class="btn month" v-for="(month, idx) in monthLists"
                        :class="{ active: month === activeItem}"
                        @click="selectItem(month.value, idx)" :key="idx">{{ month.text }}
                </button>
              </div>
            </dd>
          </dl>
        </li>
<!--        <li class="formList">-->
<!--          <dl class="wh100">-->
<!--            <dt class="formTit">제목</dt>-->
<!--            <dd class="checkSt">-->
<!--              <v-col sm="6">-->
<!--                <v-text-field label="제목 검색"-->
<!--                              v-model="param.title" v-on:keyup.enter="search"-->
<!--                              dense clearable flat outlined-->
<!--                />-->
<!--              </v-col>-->
<!--              &lt;!&ndash;              <v-btn color="#424964" @click="search" depressed dark>검색</v-btn>&ndash;&gt;-->
<!--            </dd>-->
<!--          </dl>-->
<!--        </li>-->
        <li class="formList">
          <dl class="wh100">
            <dt class="formTit">이메일</dt>
            <dd class="checkSt">
              <v-col sm="6">
                <v-text-field label="수신 이메일 주소 검색 / 정확한 이메일 주소를 입력해주세요."
                              v-model="param.recipientAddress" v-on:keyup.enter="search"
                              dense clearable flat outlined
                />
              </v-col>
              <!--              <v-btn color="#424964" @click="search" depressed dark>검색</v-btn>-->
            </dd>
          </dl>
        </li>
<!--        <li class="formList">-->
<!--          <dl class="wh100">-->
<!--            <dt class="formTit">제목</dt>-->
<!--            <dd class="checkSt">-->
<!--              <v-col sm="6">-->
<!--                <v-text-field label="제목 검색"-->
<!--                              v-model="param.title" v-on:keyup.enter="search"-->
<!--                              dense clearable flat outlined-->
<!--                />-->
<!--              </v-col>-->
<!--            </dd>-->
<!--          </dl>-->
<!--        </li>-->
        <li class="searchBtn">
          <v-btn color="#424964" depressed dark @click="search()">검색</v-btn>
        </li>
      </ul>
    </div>
    <mail-dialog :visible="mailDialog" :from="from" @close="mailDialog = false"/>

    <div class="tableBx">
      <v-data-table
          :headers="headers"
          :items="rows"
          :server-items-length="totalItems"
          item-key="requestId"
          :options.sync="options"
          class="elevation-1"
          :footer-props="{showFirstLastPage: true, 'items-per-page-options' : [10,20,50,100]}"
          disable-sort
          :single-expand="true"
          :expanded.sync="expanded"
          @item-expanded="historyDetailList"
          show-expand
      >
        <template v-slot:item.emailStatus.code="{value}">
          {{ codeName(value) }}
        </template>
<!--        <template v-slot:item.recipient="{item}">-->
<!--          <a href="javascript:;" @click="popupHistory(item.from)">-->
<!--            {{ item.recipient }}-->
<!--          </a>-->
<!--        </template>-->
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" style="padding: 20px 20px 20px 20px">

            <v-card>
<!--              <v-card-title>-->
<!--                전송 상세-->
<!--                <v-spacer></v-spacer>-->
<!--                <v-text-field-->
<!--                    v-model="searchMessage"-->
<!--                    append-icon="mdi-magnify"-->
<!--                    label="전송 상세 검색"-->
<!--                    single-line-->
<!--                    hide-details-->
<!--                ></v-text-field>-->
<!--              </v-card-title>-->
            <v-card-title class="searchStatus">
              <v-row>
                <v-col
                  class="d-flex align-center"
                  cols="12"
                >
                  <v-select
                    class="selectCss ml-4"
                    :items="mailSendStatus"
                    label="발송상태"
                    v-model="selectStatus"
                    prepend-icon="mdi-email-alert"
                  ></v-select>
                  <v-spacer></v-spacer>
                  <excel-download-button
                    @click="onExcelDownload(item, selectStatus)"
                  />
                </v-col>
              </v-row>
                <!-- <v-btn class="checkBtn" @click="getMaileHistoryDetailList()">검색</v-btn> -->
              <!-- <v-btn class="check" :class="{btnActive : success}" @click="checkEmailStatus('success')">발송 성공</v-btn>
              <v-btn class="check" :class="{btnActive : failed}" @click="checkEmailStatus('failed')">발송 실패</v-btn> -->

            </v-card-title>
              <v-data-table
                  :headers="messageHeaders"
                  :items="messages"
                  :footer-props="{showFirstLastPage: true}"
                  :options.sync="optionsDetail"
                  :server-items-length="detailTotalItems"
                  class="elevation-1"
                  sortable="false"
                  
              >
                <template v-slot:item.emailStatus.code="{value}">
                  {{ codeName(value) }}
                </template>
                <!--                <template v-slot:top>-->
                <!--                  <v-toolbar flat>-->
                <!--                    <v-toolbar-title>-</v-toolbar-title>-->
                <!--                    <v-divider-->
                <!--                        class="mx-4"-->
                <!--                        inset-->
                <!--                        vertical-->
                <!--                    ></v-divider>-->
                <!--                    <v-spacer></v-spacer>-->
                <!--                    <v-btn class="mb-2" v-on:click="createItemForm(item)">-->
                <!--                      상세 검색-->
                <!--                    </v-btn>-->
                <!--                  </v-toolbar>-->
                <!--                </template>-->
              </v-data-table>
            </v-card>
          </td>
        </template>
      </v-data-table>
    </div>
  </section>
</template>

<script>
import moment from "moment";
import mailApi from "@/api/MailApi";
import mailDialog from "./dialog/MailDialog";

import DateRageComponent from "@/views/component/DateRageComponent";
import ExcelDownloadButton from '@/views/component/ExcelDownloadButton';

export default {
  name: "MailHistory",
  components: {
    mailDialog,
    ExcelDownloadButton,
    'date-range-component': DateRageComponent,
  },
  data: () => ({
    selectStatus:'전체',
    expanded: [],
    messages: [],
    messageHeaders: [
      {text: '수신이메일', value: 'representativeRecipient', align: 'center',sortable: false,},
      {text: '발송자', value: 'senderName', align: 'center'},
      {text: '발송이메일', value: 'senderAddress', align: 'center'},
      {text: '제목', value: 'title', align: 'center'},
      {text: '발송상태', value: 'emailStatus.code', align: 'center'}
    ],
    mailSendStatus:['전체','발송준비', '발송중', '발송성공', '발송실패', '수신거부', '발송취소'],
    mailDialog: false,
    menu: false,
    menu2: false,
    activeItem: null,
    options:{},
    param: {
      searchDate: [],
      recipientAddress: null, // 수신자 이메일 주소,
      sendStatus: [] // 발송 상태 P: 발송준비중, R: 발송준비, I: 발송중, S: 발송성공, F: 발송실패, U: 수신거부, C:발송취소, PF: 일부실패
    },
    paramDetail:{
      page:1,
      size:10,
      sendStatus:null,
    },
    openDate: moment().subtract(3, 'months').format('yyyy-MM-DD'),
    closeDate: moment().format('yyyy-MM-DD'),
    monthLists: [
      {value: 1, text: '1개월'}, {value: 3, text: '3개월'}, {value: 6, text: '6개월'},
      {value: 12, text: '1년'}, {value: 0, text: '전체'}],
    rows: [],
    totalItems: 0,
    detailTotalItems:0,
    headers: [
      {text: '발송 요청 일자', value: 'requestDate.formattedDateTime', align: 'center'},
      {text: '발송 일자', value: 'sendDate.formattedDateTime', align: 'center'},
      {text: '발송 상태', value: 'emailStatus.code', align: 'center'},
      {text: '요청 건수', value: 'requestCount', align: 'center'},
      {text: '수신자수', value: 'recipientCount', align: 'center'},
      {text: '상세', value: 'data-table-expand', align: 'center'},
    ],
    searchPeriodMonth: '3',
    from: null,
    optionsDetail:{},
    emailDetailId:null,
    search:'',
  }),
  watch: {
    options: {
      handler () {
        this.searchHistory();
      },
      deep: true,
    },
    'optionsDetail':{
      handler(value){
        this.paramDetail.page = value.page;
        this.paramDetail.size = value.itemsPerPage;
        this.getMaileHistoryDetailList();
      }
    },
    'selectStatus':{
      handler(value){
        switch(value){
          case '전체' : this.paramDetail.sendStatus = null;
          this.getMaileHistoryDetailList();break;
          
          case '발송준비' : this.paramDetail.sendStatus ='R'; 
          this.getMaileHistoryDetailList();break;

          case '발송중' : this.paramDetail.sendStatus = 'I'; 
          this.getMaileHistoryDetailList();break;

          case '발송성공' : this.paramDetail.sendStatus = 'S';
          this.getMaileHistoryDetailList();break;

          case '발송실패' : this.paramDetail.sendStatus = 'F';
          this.getMaileHistoryDetailList();break;

          case '수신거부' : this.paramDetail.sendStatus = 'U';
          this.getMaileHistoryDetailList();break;

          case '발송취소' : this.paramDetail.sendStatus = 'C';
          this.getMaileHistoryDetailList();
          break;
        }
      }
    }

  },
  methods: {
    codeName(v) {
      // P: 발송준비중, R: 발송준비, I: 발송중, S: 발송성공, F: 발송실패, U: 수신거부, C:발송취소, PF: 일부실패
      switch (v) {
        case 'P' : return '발송준비중'
        case 'R' : return '발송준비'
        case 'I' : return '발송중'
        case 'S' : return '발송성공'
        case 'F' : return '발송실패'
        case 'U' : return '수신거부'
        case 'C' : return '발송취소'
        case 'PF' : return '일부실패'
      }
      return null;
    },
    getCodeByName(name) {
      switch (name) {
        case '발송준비중' : return 'P'
        case '발송준비' : return 'R'
        case '발송중' : return 'I'
        case '발송성공' : return 'S'
        case '발송실패' : return 'F'
        case '수신거부' : return 'U'
        case '일부실패' : return 'PF'
      }
      return null;
    },
    getMaileHistoryDetailList(){
        mailApi.historyDetailList(this.emailDetailId,this.paramDetail).then(data => {
          this.detailTotalItems = data.totalElements;
          this.messages = data.content;
        })
    },
    getSearchDate(searchDate = []) {
      this.param.searchDate = searchDate;
    },
    selectItem(months) {
      this.activeItem = months;
      // 0 is total
      if (this.activeItem !== 0) {
        this.param.searchDate = [this.$moment().subtract(months, "months").format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
      } else
        this.param.searchDate = [];
    },
    searchHistory() {

      const {  page, itemsPerPage, size } = this.options;
      let params = {...this.param, ...{
          page: page - 1,
          size: size ? size : itemsPerPage
        }};

      if (this.param.searchDate?.length??0 > 0) {
        params.startDateTime = this.param.searchDate[0];
        params.endDateTime = this.param.searchDate?.[1]??this.param.searchDate[0];
      } else {
        params.startDateTime = null;
        params.endDateTime = null;
      }

      mailApi.history(params).then(data => {
        this.rows = data.content;
        this.totalItems = data.totalElements;
      }).catch(error => {
        console.log(error.response);
        this.rows = [];
        this.totalItems = 0;
      })

    },
    historyDetailList({item, value}) {
      if(value) {
        this.emailDetailId = item.requestId;
        mailApi.historyDetailList(item.requestId,this.paramDetail).then(data => {
          this.detailTotalItems = data.totalElements;
          this.messages = data.content;
        })
      } else {
        this.messages = [];
      }
    },
    async onExcelDownload(item, status) {
      try {
        const { requestId } = item;
        if (!requestId) throw new Error('다운로드 받으실 내역이 전달되지 않았습니다.');
        const sendStatus = this.getCodeByName(status);
        const params = {
          sendStatus,
        };
        const { data } = await mailApi.historyDownload(requestId, params);
        const file = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const date = moment().format('YYYY-MM-DD');
        const filename = ['메일전송', date].join('-');
        const url = URL.createObjectURL(file);
        this.downloadByUrl(url, filename);
      } catch (e) {
        const { message } = e;
        window.alert(message);
      }
    },
    downloadByUrl(url, filename = '다운로드', extension = 'xlsx') {
      const link = document.createElement('a');
      link.href = url;
      link.download = [filename, extension].join('.');
      link.click();
      link.remove();
    },
    // async downloadExcel(id, params) {
    //   this.$axios
    // },
  },
  created() {
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';


.searchStatus{
  justify-content: flex-end;
}

.selectStatus{
  display: contents;
  font-size: 10rem;
}
.checkBtn{
  margin-left: 1rem;
  background-color: black !important;
  
  color: white;
  font-weight: 700;
  pointer-events: none
}

.h3Title {
  @include h3-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;


          .monthBx {
            display: flex;
            align-items: center;
            width: 280px;
            height: 34px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }

              width: 55px;
              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }

      .searchBtn {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 1.7%;
      }

    }
  }
}
</style>
